import axios from 'axios';
import {
  COURSE_LABS_GRADE_RESULTS_API,
  LAB_PASSED_NOTIFICATION_API,
  SECTION_LAB_STATUS_API,
  SET_LAB_PASSED_SEEN_NOTIFICATION,
} from 'config/constants';
import {
  LabGradeResults,
  LabGradeStatus,
  LabPassedNotification,
} from 'types/labs';

const { get } = axios;

export const getLabGradeResultsByCourseSlug = async (
  courseSlug: string,
): Promise<LabGradeResults> => {
  const response = await get<LabGradeResults>(
    `${COURSE_LABS_GRADE_RESULTS_API}?course_slug=${courseSlug}`,
  );

  return response?.data;
};

export const getLabGradeStatusByCourseSlugAndPageSlug = async (
  courseSlug: string,
  pageSlug: string,
): Promise<LabGradeStatus> => {
  const response = await get<LabGradeStatus>(
    `${SECTION_LAB_STATUS_API}?course_slug=${courseSlug}&page_slug=${pageSlug}`,
  );

  return response?.data;
};

export const getLabPassedNotification = async (): Promise<{
  items: LabPassedNotification[];
}> => {
  const response = await get<{ items: LabPassedNotification[] }>(
    LAB_PASSED_NOTIFICATION_API,
  );

  return response?.data;
};

export const setLabPassedNotificationSeen = async (
  notificationUuid: string,
): Promise<void> => {
  await get(
    SET_LAB_PASSED_SEEN_NOTIFICATION.replace(
      '<<notification_uuid>>',
      notificationUuid,
    ),
  );
};
